import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, deleteDoc, doc, getDocs, addDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { firestore } from '../config/firebaseConfig';
import { MdDeleteForever, MdEditNote, MdSave, MdEmail, MdPhone } from 'react-icons/md';
import { FaCircle } from 'react-icons/fa';
import './Administracao.css';
import BoletimEditor from '../components/BoletimEditor';


const ALLOWED_TENANT_ID = 'aGL5hULwC15AwkR9AdF4';

function Administracao() {
  const navigate = useNavigate();
  const [tenants, setTenants] = useState([]);
  const [newTenant, setNewTenant] = useState({
    empresa: '',
    adm: '',
    telefone: '',
    emailsautorizados: [],
  });
  const [editingTenantId, setEditingTenantId] = useState(null);
  const [editedTenant, setEditedTenant] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(null); // Inicializa como null para indicar verificação em andamento

  useEffect(() => {
    const tenantId = localStorage.getItem('tenantId');
    if (tenantId === ALLOWED_TENANT_ID) {
      setIsAuthorized(true); // Define como autorizado se o tenantId está correto
      fetchTenants(); // Carrega os tenants
    } else {
      setIsAuthorized(false); // Define como não autorizado
    }
  }, [navigate]);

  const fetchTenants = async () => {
    try {
      const tenantsCollection = collection(firestore, 'inquilinos');
      const tenantSnapshot = await getDocs(tenantsCollection);
      const tenantsData = tenantSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTenants(tenantsData);
    } catch (error) {
      console.error('Erro ao buscar inquilinos:', error);
    }
  };

  const handleAddTenant = async () => {
    if (!newTenant.empresa || !newTenant.adm || !newTenant.telefone || !newTenant.emailsautorizados[0]) {
      alert("Todos os campos são obrigatórios!");
      return;
    }

    try {
      await addDoc(collection(firestore, 'inquilinos'), {
        ...newTenant,
        status: 'Ativo',
        data: Timestamp.now(),
      });
      setNewTenant({ empresa: '', adm: '', telefone: '', emailsautorizados: [] });
      fetchTenants();
    } catch (error) {
      console.error('Erro ao adicionar inquilino:', error);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const tenantRef = doc(firestore, 'inquilinos', id);
      const newStatus = currentStatus === 'Ativo' ? 'Bloqueado' : 'Ativo';
      await updateDoc(tenantRef, { status: newStatus });
      fetchTenants();
    } catch (error) {
      console.error('Erro ao atualizar status do inquilino:', error);
    }
  };

  const handleEditClick = (tenant) => {
    setEditingTenantId(tenant.id);
    setEditedTenant({ ...tenant });
  };

  const handleSaveClick = async () => {
    try {
      const tenantRef = doc(firestore, 'inquilinos', editingTenantId);
      await updateDoc(tenantRef, editedTenant);
      setEditingTenantId(null);
      fetchTenants();
    } catch (error) {
      console.error('Erro ao atualizar inquilino:', error);
    }
  };

  if (isAuthorized === null) {
    return <p>Verificando autorização...</p>; // Exibe enquanto verifica a autorização
  }

  if (isAuthorized === false) {
    return (
      <div className="error-message">
        <p>Acesso negado</p>
      </div>
    );
  }

  return (
    <div className="tenant-list-container">
      <h2>Carteira de Clientes</h2>

      {/* Formulário para adicionar novo tenant */}
      <div className="add-tenant">
        <input
          type="text"
          placeholder="Nome da Empresa"
          value={newTenant.empresa}
          onChange={(e) => setNewTenant({ ...newTenant, empresa: e.target.value })}
        />
        <input
          type="text"
          placeholder="Nome do Administrador"
          value={newTenant.adm}
          onChange={(e) => setNewTenant({ ...newTenant, adm: e.target.value })}
        />
        <input
          type="email"
          placeholder="Email"
          value={newTenant.emailsautorizados[0] || ''}
          onChange={(e) => setNewTenant({ ...newTenant, emailsautorizados: [e.target.value] })}
        />
        <input
          type="text"
          placeholder="Telefone"
          value={newTenant.telefone}
          onChange={(e) => setNewTenant({ ...newTenant, telefone: e.target.value })}
        />
        
        <button onClick={handleAddTenant}>Adicionar</button>
      </div>

      {/* Lista de tenants */}
      <table className="tenant-table">
        <thead>
          <tr>
            <th>Empresa</th>
            <th>Administrador</th>
            <th>Email</th>
            <th>Telefone</th>
            <th>Usuários</th>
            <th>Tenant ID</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {tenants.map(tenant => (
            <tr key={tenant.id} className={editingTenantId === tenant.id ? 'editing-row' : ''}>
              <td>
                {editingTenantId === tenant.id ? (
                  <input
                    type="text"
                    className="edit-input"
                    value={editedTenant.empresa}
                    onChange={(e) => setEditedTenant({ ...editedTenant, empresa: e.target.value })}
                  />
                ) : (
                  tenant.empresa
                )}
              </td>
              <td>
                {editingTenantId === tenant.id ? (
                  <input
                    type="text"
                    className="edit-input"
                    value={editedTenant.adm}
                    onChange={(e) => setEditedTenant({ ...editedTenant, adm: e.target.value })}
                  />
                ) : (
                  tenant.adm
                )}
              </td>
              <td>
                {editingTenantId === tenant.id ? (
                  <input
                    type="email"
                    className="edit-input"
                    value={editedTenant.emailsautorizados[0] || ''}
                    onChange={(e) => setEditedTenant({ ...editedTenant, emailsautorizados: [e.target.value] })}
                  />
                ) : (
                  <span title={tenant.emailsautorizados[0] || ''}>
                    <MdEmail size="20" className="icon-tooltip" />
                  </span>
                )}
              </td>
              <td>
                {editingTenantId === tenant.id ? (
                  <input
                    type="text"
                    className="edit-input"
                    value={editedTenant.telefone}
                    onChange={(e) => setEditedTenant({ ...editedTenant, telefone: e.target.value })}
                  />
                ) : (
                  <span title={tenant.telefone}>
                    <MdPhone size="20" className="icon-tooltip" />
                  </span>
                )}
              </td>
              <td>{tenant.emailsautorizados ? tenant.emailsautorizados.length : 0}</td>
              <td>{tenant.id}</td>
              <td>
                <FaCircle
                  size="28"
                  style={{ color: tenant.status === 'Ativo' ? '#2e8b57' : '#E27070', cursor: 'pointer' }}
                  onClick={() => toggleStatus(tenant.id, tenant.status)}
                  title={tenant.status}
                />
              </td>
              <td>
                {editingTenantId === tenant.id ? (
                  <MdSave
                    size="28"
                    className="action-icon"
                    onClick={handleSaveClick}
                    title="Salvar"
                  />
                ) : (
                  <MdEditNote
                    size="28"
                    className="action-icon"
                    onClick={() => handleEditClick(tenant)}
                    title="Editar"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BoletimEditor />
    </div>
  );
}

export default Administracao;
